export default __webpack_public_path__ + "static/media/googleplay_it_badge_web.efdcedbf.png";